export enum RouteMode {
  fly = 'fly',
  car = 'car',
  bus = 'bus',
  transit = 'transit',
  ferry = 'ferry',
  walking = 'walking',
  railway = 'railway',
}

